import {EventEmitter, Injectable} from "@angular/core";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { AuthService } from "../../base-module/base-service/auth.service";
import { Observable } from "rxjs";
import {HttpClient, HttpHeaders} from "@angular/common/http";

@Injectable()
export class MigracaoService {

    public empresaPadrao = new EventEmitter<any>();

    constructor(private authService: AuthService,
        private _http: HttpClient,
        public utilitesService: UtilitesService) {
    }

    
    gerarStvm(params: any): Observable<any>{

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "clientes/imprimir-stvm" + env, {
            responseType: "arraybuffer",
            headers: new HttpHeaders({
                "Content-Type": "application/pdf",
                "Accept": "application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8",
                "Authorization": "Bearer " + this.authService.getToken(),
                "Access-Control-Allow-Origin": "*"
            }),
        });
    }

    gerarStvmFundo(params: any): Observable<any>{

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "migracao/imprimir-stvm-fundo" + env, {
            responseType: "arraybuffer",
            headers: new HttpHeaders({
                "Content-Type": "application/pdf",
                "Accept": "application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8",
                "Authorization": "Bearer " + this.authService.getToken(),
                "Access-Control-Allow-Origin": "*"
            }),
        });
    }

    
}